import { useDispatch } from 'react-redux'
import { EffectCallback, useEffect } from 'react'
import { formsSlice } from 'Modules'

interface UseFormConnectorOptions {
	connected?: boolean
	onMount?: boolean
	onUnmount?: boolean
}
const defaultOptions: UseFormConnectorOptions = {
	connected: true,
	onMount: true,
	onUnmount: true,
}

export const useFormConnector = (
	key: string,
	form: any,
	options?: UseFormConnectorOptions
): any => {
	const dispatch = useDispatch()
	const currentOptions = Object.assign(defaultOptions, options)
	const { connected, onMount, onUnmount } = currentOptions
	const addForm = (): void => {
		dispatch(formsSlice.actions.addForm({ key, form }))
	}
	const removeForm = (): void => {
		dispatch(formsSlice.actions.removeForm(key))
	}
	useEffect((): EffectCallback => {
		if (connected && onMount) {
			addForm()
		}
		return (): void => {
			if (connected && onUnmount) {
				removeForm()
			}
		}
	}, [])
	return [addForm, removeForm]
}
